@if (course) {
  <div
    (click)="this.close($event)"
    class="fixed modal bg-black/50 flex items-center justify-center overflow-hidden clickClose p-2"
    style="z-index: 999"
    >
    <div
      #fadeInContainer
      (animationend)="this.removeFadeInFromContainer()"
      class="bg-white w-full h-full max-h-[700px] max-w-[550px] rounded overflow-y-auto flex flex-col fadeIn rounded"
      >
      @if (this.course) {
        <div class="w-full h-40 relative mb-2 overflow-hidden">
          <img
            [attr.src]="this.generateImageUrl(this.course.image, this.course.id)"
            class="absolute w-full h-full object-cover"
            alt="Image du plat"
            style="transform: scale(1.2)"
            [style.backgroundColor]="getBackgroundColor()"
            [id]="'modal-image-' + course.id"
            (error)="this.onImageError($event)"
            />
            <mk-icon-button
              (click)="this.close(null)"
              [fullscale]="true"
              [height]="50"
              class="w-[50px] absolute right-4 top-4"
              icon="cancel"
              label=""
              useSvg="false"
              />
            </div>
          }
          @if (this.course) {
            <div class="w-full overflow-y-auto flex-1">
              <p
                [innerHTML]="this.course.name"
                class="w-full font-bold fg-noir-1 text-lg text-center pt-2"
              ></p>
              @if (this.course.description) {
                <p
                  class="w-full font-medium fg-noir-1 text-sm text-center px-4 pb-2"
                  >
                  {{ this.course.description }}
                </p>
              }
              @if (this.mode === 'day' && this.isAcceptPayment && this.course.is_extra) {
                <div
                  class="w-full px-4 py-2 border-b border-gris-3 mb-4"
                  >
                  <div
                    class="w-full h-16 rounded border border-gris-3 bg-gris-4 flex items-center px-3 justify-between"
                    >
                    <div class="flex items-center gap-2">
                      <div class="p-2 bg-vert-3">
                        <svg class="w-6 h-6 fg-vert-1">
                          <use href="/assets/images/icons/icons.svg#commmande"></use>
                        </svg>
                      </div>
                      <p class="font-bold">Total du produit</p>
                    </div>
                    <p class="font-bold">
                      {{
                      (this.quantityPresentInCart(course.id) == 0
                      ? course.price || 0
                      : this.quantityPresentInCart(course.id) * (course.price || 0)
                      ) | formatNumber
                      }}€
                    </p>
                  </div>
                </div>
              }
              @if (course.ingredients && course.ingredients.length > 0) {
                <div
                  class="px-4 pb-2 mb-4 border-b border-gris-3"
                  >
                  <p class="font-bold fg-noir-2">Ingrédients</p>
                  <div class="w-full flex items-center gap-1 flex-wrap leading-none">
                    @for (ingr of course.ingredients; track ingr; let index = $index) {
                      <div>
                        <a
              [innerText]="
                ingr.name + (index === course.ingredients.length - 1 ? '' : ',')
              "
                          [class.cursor-default]="!ingr.technical_sheet"
                          [class.hover:underline]="ingr.technical_sheet"
                          class="text-sm font-semibold lowercase fg-noir-2-contour"
                          [attr.data-external]="ingr.technical_sheet ? 'true' : 'false'"
              [href]="
                ingr.technical_sheet
                  ? this.qdmApiUrl +
                    '/upload/technical_sheets/' +
                    (this.service?.rst_id ?? '') +
                    '/' +
                    ingr.technical_sheet
                  : 'javascript:void(0);'
              "
                          [target]="ingr.technical_sheet ? '_blank' : ''"
                        ></a>
                      </div>
                    }
                  </div>
                </div>
              }
              @if (this.course.labels && this.course.labels.length > 0) {
                <div
                  class="px-4 py-2 w-full"
                  >
                  <p class="font-bold fg-noir-2 mb-2">Liste des labels</p>
                  <div class="w-full flex items-center flex-wrap">
                    @for (label of this.course.labels; track label) {
                      <small-badge
                        [backgroundColor]="label.color"
                        [iconUrl]="normalizeUrl(label.logo)"
                        [label]="label.comment"
                        class="mr-2 mb-2 h-6 text-xs"
                        />
                    }
                  </div>
                </div>
              }
              @if (this.course.allergens && this.course.allergens.length > 0) {
                <div
                  class="px-4 py-2 w-full"
                  >
                  <p class="font-bold fg-noir-2 mb-2">Liste des allergènes</p>
                  <div class="w-full flex flex-col">
                    @for (allergen of course.allergens; track allergen) {
                      <div
                        class="w-full flex items-center gap-2 mb-1"
                        >
                        <img
                          alt=""
                          [attr.src]="this.generateAllergenImage(allergen.id)"
                          class="w-6 h-6 object-contain"
                          />
                          <p
                            [innerText]="allergen.name"
                            class="flex-1 break-all text-sm font-medium"
                          ></p>
                        </div>
                      }
                    </div>
                  </div>
                }
              </div>
            }
          </div>
          @if (this.askForEmail) {
            <div
              class="fixed modal bg-black/50 flex items-center justify-center overflow-hidden clickClose p-2"
              (click)="this.closeAskForEmail($event)"
              >
              <div class="bg-white min-w-64 min-h-32 rounded p-4">
                <p class="fg-noir-2 font-semibold">
                  Veuillez entrer une adresse e-mail pour continuer
                </p>
                <mk-text-input
                  class="mt-2 mb-2"
                  type="text"
                  textAlign="left"
                  placeholder="email@domaine.com"
                  classes="text-xs"
                  #email
                  />
                  <mk-green-action-button
                    class="mt-2"
                    [data]="this"
                    [callback]="this._handle_setEmail"
                    [enabled]="this.isEmailValid()"
                    baseLabel="Noter le plat"
                    baseIcon="star"
                    />
                  </div>
                </div>
              }
              @if (this.showCommentModal) {
                <div
                  class="fixed modal bg-black/50 flex items-center justify-center overflow-hidden clickClose p-2"
                  (click)="this.closeCommentModal($event)"
                  >
                  <div class="bg-white min-w-64 min-h-32 rounded p-4">
                    <span class="text-xs font-bold px-2 fg-gris-1">Adresse e-mail</span>
                    <mk-text-input
                      #commentEmail
                      class="border-none"
                      type="text"
                      [disabled]="this.email !== '' || this.alreadyCommented !== undefined"
                      textAlign="left"
                      [value]="this.alreadyCommented?.email || this.email"
                      placeholder="Votre adresse email"
        [classes]="
          'text-xs ' +
          (this.email !== '' || this.alreadyCommented ? '!text-gray-400' : '')
        "
                      />
                      <span class="text-xs font-bold px-2 fg-gris-1 mt-2">Commentaire</span>
                      <mk-text-input
                        #commentText
                        class="mb-2 border-none"
                        type="text"
                        [disabled]="this.alreadyCommented !== undefined"
                        textAlign="left"
                        placeholder="Votre commentaire"
                        classes="text-xs"
                        [value]="this.alreadyCommented?.comment || ''"
        [classes]="
          'text-xs ' +
          (this.email !== '' || this.alreadyCommented ? '!text-gray-400' : '')
        "
                        />
                        <mk-green-action-button
                          class="my-4 block h-10"
                          [data]="this"
                          [callback]="this._handle_comment"
        [enabled]="
          !this.alreadyCommented &&
          this.emailRegex.test(this.commentEmail().value) &&
          this.commentText().value.trim().length > 0
        "
                          baseLabel="Commenter"
                          baseIcon="comment"
                          />
                          <mk-action-button
                            class="mt-1 h-8"
                            [data]="this"
                            [callback]="this._closeComments"
                            [enabled]="true"
                            baseLabel="Annuler"
                            baseIcon="chevron_left"
                            />
                          </div>
                        </div>
                      }
                    </div>
                  }
